export default function ({ store, route, redirect }) {
  const routesRequiringOrg = ['/dashboard', '/contacts', '/billing']

  if (routesRequiringOrg.includes(route.path) && !store.state.organizations?.currentOrganization) {
    return redirect('/documents')
  }
}
